import React, { useEffect, useState } from 'react';

import '../styles/Home.css';
import '../styles/About.css';
import '../styles/Responsive.css';

import Footer from '../components/Footer.js';
import axiosPost from '../helper/axios-helper.js';

export default function About() {
    const [selectedIndex, setSelectedIndex] = useState(0); 
    const [timelines, setHistory] = useState([]);

    const [ image, setImage ] = useState('');

    useEffect(() => {
        fetchContent()
    }, [])

    const fetchContent = () => {

        axiosPost('content/fetch', {}, {page: 'about_mission'}, (data) => {

        const { success, response } = data;

        if (success) {
            
            setImage(data.data.image)
            

        } else {
            
        }

        })

    }

    const fetchHistory = () => {
        
        axiosPost('about/history/fetch', {}, {}, (data) => {
            const { success, response } = data;
            if (success) {
                setHistory(data.data);
            }
        })
    }

    useEffect(() => {
        fetchHistory();
        fetchContent();
    }, [])

   // Track if user has manually selected a timeline item
   const [userHasInteracted, setUserHasInteracted] = useState(false);
   
   // Only scroll when user has manually selected an item
   useEffect(() => {
        if (!userHasInteracted) return;
        
        const selectedElement = document.querySelector('.timeline-container.selected');
        if (selectedElement) {
            selectedElement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
    }, [selectedIndex, userHasInteracted]);
    
   function renderHistoryTimeline(){

    const render_items = timelines.map((timeline, index) => {
        const isSelected = selectedIndex === index;
        
        return (
            <div 
                key={timeline.id}
                className={`timeline-container ${isSelected ? 'selected' : ''}`} 
                onClick={() => {
                    setSelectedIndex(index);
                    setUserHasInteracted(true);
                }}
            >
                <div className='timeline-header-container'>
                    <div className={`timeline-header-circle ${isSelected ? 'selected' : ''}`}></div>
                    <div className={`timeline-header-year ${isSelected ? 'selected' : ''}`}>
                        {timeline.year}
                    </div>
                    <div className='timeline-header-text'>
                        {timeline.title}
                    </div>
                </div>

                <div className='timeline-image-container'>
                    <img 
                        className='timeline-image' 
                        src={timeline.image} 
                        alt={`${timeline.year} - ${timeline.title}`}
                        loading="lazy"
                        draggable={false}
                    />
                </div>

                <div className='timeline-text' dangerouslySetInnerHTML={{ __html: timeline.text }} />
            </div>
        );
    });

    return render_items;
}
    
  return (
    <div className='container' style={{paddingTop: '100px'}}>

        <div className='about-vision-container'>
            <div className='about-vision-text-container'>
                <div className='about-vision-item'>
                    <div className='about-vision-item-title'>
                        Our <span>Mission</span>
                        <div className='about-vision-item-bar'></div>
                    </div>
                    <div className='about-vision-item-text'>To drive ICT innovation and collaboration across the Caribbean, fostering regional development through telecommunications excellence.</div>
                </div>
                <div className='about-vision-item alt'>
                    <div className='about-vision-item-title alt'>
                        And <span>Vision.</span>
                        <div className='about-vision-item-bar alt'></div>
                    </div>
                    <div className='about-vision-item-text'>A connected Caribbean at the forefront of global ICT advancements, empowering communities and businesses through cutting-edge telecommunications solutions.</div>
                </div>
            </div>
            <div className='about-vision-video-container' style={{backgroundImage: `url(${image})`}}>
                {/* <video style={{height: '100%', width: '100%'}} controls autoPlay loop>
                    <source src={process.env.PUBLIC_URL + '/assets/videos/conference.mp4'} type='video/mp4'/>
                </video> */}
            </div>
        </div>

        <div className='about-history-container'>
            <div className='about-history-header'>History</div>
            <div className='about-history-items-container' style={{marginTop: '50px'}}>
                { renderHistoryTimeline() }
            </div>
        </div>


    </div>
  )
}
